import { createContext } from 'react';

export const FiltersSwipeDialogContext = createContext<{
  /** Общая высота  */
  height: string | number;
}>({
  height: 0,
});
